import { render } from "./QuestionTwoScreen.vue?vue&type=template&id=5d228ae5&scoped=true&lang=html"
import script from "./QuestionTwoScreen.vue?vue&type=script&lang=js"
export * from "./QuestionTwoScreen.vue?vue&type=script&lang=js"

import "./QuestionTwoScreen.vue?vue&type=style&index=0&id=5d228ae5&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/progressive/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d228ae5"]])

export default __exports__